import { render, staticRenderFns } from "./LuminaireLineTool.vue?vue&type=template&id=2563ecb6"
import script from "./LuminaireLineTool.vue?vue&type=script&lang=js"
export * from "./LuminaireLineTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports